import { useQuery } from '@tanstack/react-query';
import { vehicleDetailsApi } from '../api/vehicleDetailsApi';
import { vehicleDetailsQueryKeys } from '../api/queryKeys';

const useVehicleOverview = (vehicleId, period) => {
  const query = useQuery({
    queryKey: vehicleDetailsQueryKeys.overview(vehicleId, period),
    queryFn: () => vehicleDetailsApi.getOverview(vehicleId, period),
    enabled: Boolean(vehicleId),
    keepPreviousData: true,
    staleTime: 300000,
  });

  return {
    data: query.data ?? null,
    loading: query.isLoading,
    updating: query.isFetching && !query.isLoading,
    error: query.error?.message || '',
    reload: query.refetch,
  };
};

export default useVehicleOverview;
